/* eslint-disable max-len */
export default {
  empty: '',
  messageType: {
    SMS: 'SMS',
    LMS: 'LMS',
    MMS: 'MMS',
    FRIENDTALK_TEXT: '브랜드 메세지(자유형) 텍스트',
    FRIENDTALK_IMAGE: '브랜드 메세지(자유형) 이미지',
    FRIENDTALK_WIDE_IMAGE: '브랜드 메세지(자유형) 와이드 이미지',
    FRIENDTALK_WIDE_ITEM_LIST: '브랜드 메세지(자유형) 와이드 아이템 리스트',
    FRIENDTALK_COMMERCE: '브랜드 메세지(자유형) 커머스',
    FRIENDTALK_CAROUSEL_FEED: '브랜드 메세지(자유형) 캐러셀 피드',
    FRIENDTALK_CAROUSEL_COMMERCE: '브랜드 메세지(자유형) 캐러셀 커머스',
    FRIENDTALK_PREMIUM_VIDEO: '브랜드 메세지(자유형) 프리미엄 동영상',
    ALIMTALK_BA: '알림톡 기본형',
    ALIMTALK_EX: '알림톡 부가정보형',
    ALIMTALK_AD: '알림톡 채널추가형',
    ALIMTALK_MI: '알림톡 복합형',
    BRANDTALK_TEXT: '브랜드 텍스트',
    BRANDTALK_IMAGE: '브랜드 이미지',
    BRANDTALK_WIDE_IMAGE: '브랜드 와이드 이미지',
    BRANDTALK_WIDE_ITEM_LIST: '브랜드 와이드 아이템 리스트',
    BRANDTALK_CAROUSEL_FEED: '브랜드 캐러셀 피드',
    BRANDTALK_CAROUSEL_COMMERCE: '브랜드 캐러셀 커머스',
    BRANDTALK_COMMERCE: '브랜드 커머스',
    BRANDTALK_PREMIUM_VIDEO: '브랜드 프리미엄 동영상',
  },
  newline: '줄바꿈: 최대 {count}개',
  targetingType: {
    m: 'M : 광고주 마수동 유저(카카오 수신 동의)',
    n: 'N : 광고주 마수동 유저(카카오 수신 동의) - 채널 친구',
    i: 'I : 광고주 발송 요청 대상 ∩ 채널 친구',
  },
  imageType: {
    MMS_IMAGE: '일반 이미지',
    NORMAL_IMAGE: '일반',
    WIDE_IMAGE: '와이드',
    WIDE_ITEM_LIST_IMAGE: '와이드 아이템 리스트',
    MAIN_WIDE_ITEM_LIST_IMAGE: '메인 와이드 아이템 리스트',
    CAROUSEL_FEED_IMAGE: '캐러셀 피드',
    CAROUSEL_COMMERCE_IMAGE: '캐러셀 커머스',
  },
  buttonType: {
    webLink: '웹링크',
    appLink: '앱링크',
    addChannel: '채널 추가',
    businessForm: '비즈니스 폼',
    businessFormOptions: {
      surveys: '톡에서 설문하기',
      applications: '톡에서 응모하기',
      reservations: '톡에서 예약하기',
    },
    botKeyword: '봇 키워드',
  },
  couponType: {
    numberDiscount: 'OO원 할인 쿠폰',
    percentDiscount: 'OO% 할인 쿠폰',
    deliveryDiscount: '배송비 할인 쿠폰',
    freeCoupon: 'OO 무료 쿠폰',
    upCoupon: 'OO UP 쿠폰',
  },
  validation: {
    templateName: {
      alreadyUse: '이미 사용 중인 템플릿명 입니다.',
    },
    buttons: {
      list: {
        max: '버튼은 최대 {count}개 까지만 설정 가능합니다.',
      },
      couponLimit: '쿠폰 설정 시, 버튼은 최대 {count}개 까지만 설정 가능합니다. 버튼 삭제 후 사용해 주세요.',
    },
    content: {
      max: '내용은 1,000자 이하여야 합니다.',
      advertPhrase: '광고성 메시지에는 본문 맨 앞에 \'(광고)\' 문구가 반드시 포함되어야 합니다.',
      arsNumber: '광고성 메시지에는 선택한 수신 거부 번호가 반드시 포함되어야 합니다.',
      required: '내용은 필수입니다.',
    },
    arsNumber: {
      required: '수신거부 번호는 필수입니다.',
    },
    button: {
      androidDeepLink: {
        max: '안드로이드 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        required: '안드로이드 앱 링크는 필수입니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: '안드로이드 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      iosDeepLink: {
        max: 'iOS 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: 'iOS 앱 링크는 1,000자 이하여야 합니다.',
        required: 'iOS 앱 링크는 필수입니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: 'iOS 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      mobileLink: {
        max: '모바일 웹 링크는 2,000자 이하여야 합니다.',
        brandMax: '모바일 웹 링크는 1,000자 이하여야 합니다.',
        required: '모바일 웹 링크는 필수입니다.',
        laxUrl: '버튼 모바일 웹 링크는 URL 형식이어야 합니다.',
        webLinkScheme: '웹링크 버튼의 모바일 웹 링크는 http:// 또는 https://로 시작해야 합니다. (앱스킴 링크 사용 불가)',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: '버튼 모바일 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      name: {
        dbmax: '버튼 명에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: {
          FRIENDTALK_TEXT: '버튼 명은 14자 이하여야 합니다.',
          FRIENDTALK_IMAGE: '버튼 명은 14자 이하여야 합니다.',
          FRIENDTALK_WIDE_IMAGE: '버튼 명은 8자 이하여야 합니다.',
          FRIENDTALK_WIDE_ITEM_LIST: '버튼 명은 8자 이하여야 합니다.',
          FRIENDTALK_COMMERCE: '버튼 명은 8자 이하여야 합니다.',
          FRIENDTALK_CAROUSEL_FEED: '버튼 명은 8자 이하여야 합니다.',
          FRIENDTALK_CAROUSEL_COMMERCE: '버튼 명은 8자 이하여야 합니다.',
          FRIENDTALK_PREMIUM_VIDEO: '버튼 명은 8자 이하여야 합니다.',

          BRANDTALK_TEXT: '버튼 명은 14자 이하여야 합니다.',
          BRANDTALK_IMAGE: '버튼 명은 14자 이하여야 합니다.',
          BRANDTALK_WIDE_IMAGE: '버튼 명은 8자 이하여야 합니다.',
          BRANDTALK_COMMERCE: '버튼 명은 8자 이하여야 합니다.',
          BRANDTALK_WIDE_ITEM_LIST: '버튼 명은 8자 이하여야 합니다.',
          BRANDTALK_CAROUSEL_FEED: '버튼 명은 8자 이하여야 합니다.',
          BRANDTALK_CAROUSEL_COMMERCE: '버튼 명은 8자 이하여야 합니다.',
          BRANDTALK_PREMIUM_VIDEO: '버튼 명은 8자 이하여야 합니다.',
        },
        required: '버튼 명은 필수입니다.',
        disallowedVariable: '버튼 명은 변수를 사용할 수 없습니다.',
        businessForm: '비즈니스 폼 버튼명은 \'톡에서 설문하기\', \'톡에서 응모하기\', \'톡에서 예약하기\' 중 하나로만 입력할 수 있습니다.',
        disallowedUrlLink: '버튼 명은 URL 형식을 포함할 수 없습니다.',
        enabledVariable: '버튼 명에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      pcLink: {
        max: 'PC 웹 링크는 2,000자를 초과할 수 없습니다.',
        brandMax: 'PC 웹 링크는 1,000자를 초과할 수 없습니다.',
        laxUrl: '버튼 PC 링크는 URL 형식이어야 합니다.',
        webLinkScheme: '웹링크 버튼의 PC 링크는 http:// 또는 https://로 시작해야 합니다. (앱스킴 링크 사용 불가)',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: '버튼 PC 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      type: {
        allowedType: '허용하지 않는 버튼 유형입니다.',
        businessFormEnded: '비즈니스폼(BF) 버튼은 카카오 정책에 따라 지원이 종료되었습니다. 다른 버튼 유형으로 변경해 주세요.',
        required: '버튼 유형은 필수입니다.',
      },
      appLink: '모바일 웹, iOS 앱, 안드로이드 앱 링크 중에서 최소 2개 이상의 링크를 입력해야 합니다.',
      bizFormKey: {
        required: '비즈니스 ID는 필수입니다.',
        disallowedVariable: '비즈니스 ID는 변수를 사용할 수 없습니다.',
        enabledVariable: '비즈니스 ID에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      addChannel: {
        position: '채널추가 타입은 브랜드 텍스트, 이미지의 경우 첫번째 버튼으로, 그 외 메시지 타입의 경우 마지막 버튼으로 등록해야합니다.',
        max: '채널추가 타입은 하나만 있어야 합니다.',
        targeting: '채널추가 버튼은 타겟팅이 M 또는 N 일 때만 사용할 수 있습니다.',
      },
      businessForm: {
        position: '비즈니스 폼 버튼은 첫 번째 버튼으로만 등록할 수 있습니다.',
      },
    },
    carouselTail: {
      mobileLink: {
        max: '모바일 웹 링크는 2,000자 이하여야 합니다.',
        brandMax: '모바일 웹 링크는 1,000자 이하여야 합니다.',
        required: '모바일 웹 링크는 필수입니다.',
        url: '모바일 웹 링크는 URL 형식이어야 합니다.',
        disallowedVariable: '모바일 웹 링크는 변수를 사용할 수 없습니다.',
        enabledVariable: '모바일 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      pcLink: {
        max: 'PC 웹 링크는 2,000자 이하여야 합니다.',
        brandMax: 'PC 웹 링크는 1,000자 이하여야 합니다.',
        url: 'PC 웹 링크는 URL 형식이어야 합니다.',
        disallowedVariable: 'PC 웹 링크는 변수를 사용할 수 없습니다.',
        enabledVariable: 'PC 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      androidDeepLink: {
        max: '안드로이드 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        disallowedVariable: '안드로이드 앱 링크는 변수를 사용할 수 없습니다.',
        enabledVariable: '안드로이드 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      iosDeepLink: {
        max: 'iOS 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: 'iOS 앱 링크는 1,000자 이하여야 합니다.',
        disallowedVariable: 'iOS 앱 링크는 변수를 사용할 수 없습니다.',
        enabledVariable: 'iOS 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
    },
    coupon: {
      templateName: {
        required: '쿠폰 템플릿명은 필수입니다.',
        max: '쿠폰 템플릿명은 25자 이하여야 합니다.',
      },
      type: {
        allowedType: '허용하지 않는 쿠폰 유형입니다.',
      },
      name: {
        required: '쿠폰 이름은 필수입니다.',
        deliveryDiscount: {
          length: '쿠폰 이름은 비어 있어야 합니다.',
        },
        freeCoupon: {
          max: '쿠폰값은 7자 이하여야 합니다.',
          min: '쿠폰값을 입력해 주세요.',
        },
        max: '쿠폰명은 50자 이하여야 합니다.',
        numberDiscount: {
          integer: '쿠폰값은 양의 정수여야 합니다.',
          max: '쿠폰값은 99,999,999 이하의 숫자여야 합니다.',
          min: '쿠폰값을 입력해 주세요.',
        },
        percentDiscount: {
          integer: '쿠폰값은 양의 정수여야 합니다.',
          max: '쿠폰 값은 100 이하의 숫자여야 합니다.',
          min: '쿠폰값을 입력해 주세요.',
        },
        upCoupon: {
          max: '쿠폰명은 7자 이하여야 합니다.',
          min: '쿠폰명을 입력해 주세요.',
        },
        enabledVariable: '쿠폰명에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      description: {
        FRIENDTALK_TEXT: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        FRIENDTALK_IMAGE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        FRIENDTALK_WIDE_IMAGE: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        FRIENDTALK_WIDE_ITEM_LIST: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        FRIENDTALK_COMMERCE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        FRIENDTALK_CAROUSEL_FEED: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        FRIENDTALK_CAROUSEL_COMMERCE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        FRIENDTALK_PREMIUM_VIDEO: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        BRANDTALK_TEXT: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        BRANDTALK_IMAGE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        BRANDTALK_WIDE_IMAGE: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        BRANDTALK_WIDE_ITEM_LIST: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        BRANDTALK_COMMERCE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        BRANDTALK_CAROUSEL_FEED: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        BRANDTALK_CAROUSEL_COMMERCE: { max: '쿠폰 상세 설명은 12자 이하여야 합니다.' },
        BRANDTALK_PREMIUM_VIDEO: { max: '쿠폰 상세 설명은 18자 이하여야 합니다.' },
        max: '쿠폰 상세 설명은 50자 이하여야 합니다.',
        required: '쿠폰 상세 설명은 필수입니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '쿠폰 상세 설명은 URL 형식을 포함할 수 없습니다.',
        enabledVariable: '쿠폰 상세 설명에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      mobileLink: {
        laxUrl: '버튼 모바일 웹 링크는 URL 형식이어야 합니다.',
        max: '모바일 웹 링크는 2,000자 이하여야 합니다.',
        url: '쿠폰 모바일 링크는 URL 형식이어야 합니다.',
        brandMax: '모바일 웹 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: '쿠폰 모바일 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      pcLink: {
        max: 'PC 웹 링크는 2,000자 이하여야 합니다.',
        url: 'PC 웹 링크는 URL 형식이어야 합니다.',
        brandMax: 'PC 웹 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: 'PC 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      iosDeepLink: {
        max: 'IOS 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: 'IOS 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: 'IOS 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      androidDeepLink: {
        max: '안드로이드 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        enabledVariable: '안드로이드 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      link: {
        required: `링크 파라미터의 경우 다음 두 가지 중 하나를 충족해야 합니다.
          * 모바일 웹 링크 사용
          * 안드로이드 또는 iOS 링크 둘 중 하나에 카카오 채널 쿠폰 URL(포맷: alimtalk=coupon://) 사용`,
      },
    },
    sms: {
      content: {
        max: 'SMS 내용은 45자 이하여야 합니다.',
        required: 'SMS 내용은 필수입니다.',
        enabledVariable: 'SMS 내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedEmoji: 'SMS 내용은 이모지를 사용할 수 없습니다.',
      },
    },
    lms: {
      subject: {
        max: 'LMS 제목은 120자 이하여야 합니다.',
        required: 'LMS 제목은 필수입니다.',
        disallowedVariable: 'LMS 제목은 변수를 사용할 수 없습니다.',
        disallowedEmoji: 'LMS 제목은 이모지를 사용할 수 없습니다.',
      },
      content: {
        max: 'LMS 내용은 1,000자 이하여야 합니다.',
        required: 'LMS 내용은 필수입니다.',
        enabledVariable: 'LMS 내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedEmoji: 'LMS 내용은 이모지를 사용할 수 없습니다.',
      },
    },
    mms: {
      content: {
        max: 'MMS 내용은 1,000자 이하여야 합니다.',
        required: 'MMS 내용은 필수입니다.',
        enabledVariable: 'MMS 내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedEmoji: 'MMS 내용은 이모지를 사용할 수 없습니다.',
      },
      image: {
        imageId: 'MMS 이미지는 UUID 형식이어야 합니다.',
        required: 'MMS 이미지는 필수입니다.',
      },
      subject: {
        disallowedVariable: 'MMS 제목은 변수를 사용할 수 없습니다.',
        max: 'MMS 제목은 120자 이하여야 합니다.',
        required: 'MMS 제목은 필수입니다.',
        disallowedEmoji: 'MMS 제목은 이모지를 사용할 수 없습니다.',
      },
    },
    FRIENDTALK_TEXT: {
      buttons: {
        coupon: { maxFive: '쿠폰이 포함된 경우, 버튼은 최대 4개까지만 추가할 수 있습니다.' },
        maxLength: '버튼은 최대 5개까지만 추가할 수 있습니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        dbmax: '내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '내용은 1,300자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 99회까지만 허용됩니다.',
        required: '내용은 필수입니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
      },
    },
    FRIENDTALK_IMAGE: {
      buttons: {
        coupon: { maxFive: '쿠폰이 포함된 경우, 버튼은 최대 4개까지만 추가할 수 있습니다.' },
        maxLength: '버튼은 최대 5개까지만 추가할 수 있습니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        required: '내용은 필수입니다.',
        dbmax: '내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '내용은 1,300자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 99회까지만 허용됩니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        max: '이미지 링크는 2,000자 이하여야 합니다.',
        brandMax: '이미지 링크는 1,000자 이하여야 합니다.',
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        enabledVariable: '이미지 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
    },
    FRIENDTALK_WIDE_IMAGE: {
      buttons: { maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        required: '내용은 필수입니다.',
        dbmax: '내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '내용은 76자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 5회까지만 허용됩니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        max: '이미지 링크는 2,000자 이하여야 합니다.',
        brandMax: '이미지 링크는 1,000자 이하여야 합니다.',
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        enabledVariable: '이미지 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
    },
    FRIENDTALK_WIDE_ITEM_LIST: {
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      header: {
        dbmax: '메인 아이템 제목에 입력된 내용이 허용된 최대 길이를 초과했습니다.',
        max: '메인 아이템 제목은 20자 이하여야 합니다.',
        required: '메인 아이템 제목은 필수입니다.',
        enabledVariable: '메인 아이템 제목에 허용하지 않는 변수가 포함되어 있습니다.',
        maxLine: '메인 아이템 제목에서는 줄바꿈을 사용할 수 없습니다.',
        disallowedUrlLink: '메인 아이템 제목은 URL 형식을 포함할 수 없습니다.',
      },
      content: {
        firstMax: '메인 아이템 내용은 25자 이하여야 합니다.',
        max: '내용은 30자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 1회까지만 허용됩니다.',
        required: '내용은 필수입니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '아이템 내용은 URL 형식을 포함할 수 없습니다.',
      },
      mobileLink: {
        laxUrl: '모바일 웹 링크는 URL 형식이어야 합니다.',
        max: '모바일 웹 링크는 2,000자 이하여야 합니다.',
        brandMax: '모바일 웹 링크는 1,000자 이하여야 합니다.',
        required: '모바일 웹 링크은 필수입니다.',
        enabledVariable: '모바일 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      pcLink: {
        laxUrl: 'PC 웹 링크는 URL 형식이어야 합니다.',
        max: 'PC 웹 링크는 2,000자 이하여야 합니다.',
        brandMax: 'PC 웹 링크는 1,000자 이하여야 합니다.',
        enabledVariable: 'PC 웹 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      iosDeepLink: {
        max: 'iOS 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: 'iOS 앱 링크는 1,000자 이하여야 합니다.',
        enabledVariable: 'iOS 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      androidDeepLink: {
        max: '안드로이드 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '안드로이드 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      buttons: { maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      list: {
        max: '아이템은 최대 4개까지만 추가할 수 있습니다.',
        min: '아이템은 최소 3개 이상이어야 합니다.',
      },
    },
    FRIENDTALK_COMMERCE: {
      buttons: {
        maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      additionalContent: {
        dbmax: '부가 정보에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '부가 정보는 34자 이하여야 합니다.',
        enabledVariable: '부가 정보에 허용하지 않는 변수가 포함되어 있습니다.',
        maxLine: '부가 정보의 줄바꿈은 최대 1회까지만 허용됩니다.',
        disallowedUrlLink: '부가 정보는 URL 형식을 포함할 수 없습니다.',
      },
      discountFixed: {
        dbmax: '정액 할인 가격에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        integer: '정액 할인 가격은 숫자여야 합니다.',
        max: '정액 할인 가격은 999,999 이하의 숫자여야 합니다.',
        min: '정액 할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '정액 할인 가격은 숫자여야 합니다.',
        required: '정액 할인 가격은 필수입니다.',
        enabledVariable: '정액 할인 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      discountPrice: {
        dbmax: '할인 가격에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        integer: '할인 가격은 숫자여야 합니다.',
        max: '할인 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '할인 가격은 숫자여야 합니다.',
        required: '할인 가격은 필수입니다.',
        enabledVariable: '할인 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      discountRate: {
        dbmax: '할인율에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        integer: '할인율은 숫자여야 합니다.',
        max: '할인율은 100 이하의 숫자여야 합니다.',
        min: '할인율은 0 이상의 숫자여야 합니다.',
        positive: '할인율은 숫자여야 합니다.',
        required: '할인율은 필수입니다.',
        enabledVariable: '할인율에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 2,000자 이하여야 합니다.',
        brandMax: '이미지 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '이미지 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      regularPrice: {
        dbmax: '정상 가격에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        integer: '정상 가격은 숫자여야 합니다.',
        max: '정상 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '정상 가격은 0 이상의 숫자여야 합니다.',
        positive: '정상 가격은 숫자여야 합니다.',
        required: '정상 가격은 필수입니다.',
        enabledVariable: '정상 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      title: {
        dbmax: '상품명에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '상품명은 30자 이하여야 합니다.',
        required: '상품명은 필수입니다.',
        enabledVariable: '상품명에 허용하지 않는 변수가 포함되어 있습니다.',
        maxLine: '상품명에서는 줄바꿈을 사용할 수 없습니다.',
        disallowedUrlLink: '상품명은 URL 형식을 포함할 수 없습니다.',
      },
      commerce: '할인 가격 입력시, 할인율 또는 정액 할인 가격 중 하나는 반드시 입력해야 합니다.',
      brandCommerce: '할인율 또는 정액할인가격 둘중에 하나만 입력해야 합니다.',
    },
    FRIENDTALK_CAROUSEL_FEED: {
      buttons: {
        maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        dbmax: '내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '내용은 180자 이하여야 합니다.',
        required: '내용은 필수입니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '내용은 URL 형식을 포함할 수 없습니다.',
        maxLine: '내용의 줄바꿈은 최대 2회까지만 허용됩니다.',
      },
      header: {
        dbmax: '제목에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '제목은 20자 이하여야 합니다.',
        required: '제목은 필수입니다.',
        enabledVariable: '제목에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '제목은 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 2,000자 이하여야 합니다.',
        brandMax: '이미지 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '이미지 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      list: {
        max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
        min: '캐러셀은 최소 2개 이상이어야 합니다.',
      },
    },
    FRIENDTALK_CAROUSEL_COMMERCE: {
      buttons: {
        maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      androidDeepLink: {
        max: '인트로 안드로이드 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '인트로 안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '인트로 안드로이드 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      content: {
        dbmax: '인트로 내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '인트로 내용은 50자 이하여야 합니다.',
        required: '인트로 내용은 필수입니다.',
        enabledVariable: '인트로 내용에 허용하지 않는 변수가 포함되어 있습니다.',
        maxLine: '인트로 내용의 줄바꿈은 최대 2회까지만 허용됩니다.',
        disallowedUrlLink: '인트로 내용은 URL 형식을 포함할 수 없습니다.',
      },
      discountFixed: {
        integer: '정액 할인 가격은 숫자여야 합니다.',
        max: '정액 할인 가격은 999,999 이하의 숫자여야 합니다.',
        min: '정액 할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '정액 할인 가격은 숫자여야 합니다.',
        enabledVariable: '정액 할인 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      discountPrice: {
        integer: '할인 가격은 숫자여야 합니다.',
        max: '할인 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '할인 가격은 숫자여야 합니다.',
        enabledVariable: '할인 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      discountRate: {
        integer: '할인율은 숫자여야 합니다.',
        max: '할인율은 100 이하의 숫자여야 합니다.',
        min: '할인율은 0 이상의 숫자여야 합니다.',
        positive: '할인율은 숫자여야 합니다.',
        enabledVariable: '할인율에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      header: {
        dbmax: '인트로 제목에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '인트로 제목은 20자 이하여야 합니다.',
        required: '인트로 제목은 필수입니다.',
        enabledVariable: '인트로 제목에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '인트로 제목은 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지의 아이디는 UUID 형식이어야 합니다.',
        ratio: '이미지의 가로 : 세로 비율이 일치해야 합니다.',
        required: '이미지는 필수입니다.',
      },
      introImage: {
        imageId: '인트로 이미지의 아이디는 UUID 형식이어야 합니다.',
        ratio: '인트로 이미지의 가로 : 세로 비율이 일치해야 합니다.',
        required: '인트로 이미지는 필수입니다.',
      },
      iosDeepLink: {
        max: '인트로 iOS 앱 링크는 2,000자 이하여야 합니다.',
        brandMax: '인트로 iOS 앱 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '인트로 iOS 앱 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      list: {
        length: {
          max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
          min: '캐러셀은 최소 2개 이상이어야 합니다.',
        },
      },
      mobileLink: {
        required: '인트로 링크를 사용하면 인트로 모바일 링크는 필수입니다.',
        laxUrl: '인트로 모바일 링크는 URL 형식이어야 합니다.',
        max: '인트로 모바일 링크는 2,000자 이하여야 합니다.',
        brandMax: '인트로 모바일 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '인트로 모바일 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      pcLink: {
        laxUrl: '인트로 PC 링크는 URL 형식이어야 합니다.',
        max: '인트로 PC 링크는 2,000자 이하여야 합니다.',
        brandMax: '인트로 PC 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '인트로 PC 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      regularPrice: {
        integer: '정상 가격은 숫자여야 합니다.',
        max: '정상 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '정상 가격은 0 이상의 숫자여야 합니다.',
        positive: '정상 가격은 숫자여야 합니다.',
        required: '정상 가격은 필수입니다.',
        enabledVariable: '정상 가격에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      title: {
        max: '상품명은 30자 이하여야 합니다.',
        required: '상품명은 필수입니다.',
        enabledVariable: '상품명에 허용하지 않는 변수가 포함되어 있습니다.',
        maxLine: '상품명에서는 줄바꿈을 사용할 수 없습니다.',
        disallowedUrlLink: '상품명은 URL 형식을 포함할 수 없습니다.',
      },
      commerce: '할인 가격 입력시, 할인율 또는 정액 할인 가격 중 하나는 반드시 입력해야 합니다.',
      brandCommerce: '할인율 또는 정액할인가격 둘중에 하나만 입력해야 합니다.',
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 2,000자 이하여야 합니다.',
        brandMax: '이미지 링크는 1,000자 이하여야 합니다.',
        enabledVariable: '이미지 링크에 허용하지 않는 변수가 포함되어 있습니다.',
      },
      additionalContent: {
        dbmax: '부가 정보에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '부가 정보는 34자 이하여야 합니다.',
        maxLine: '부가 정보의 줄바꿈은 최대 1회까지만 허용됩니다.',
        enabledVariable: '부가 정보에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '부가 정보는 URL 형식을 포함할 수 없습니다.',
      },
    },
    FRIENDTALK_PREMIUM_VIDEO: {
      buttons: { maxLength: '버튼은 최대 1개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        dbmax: '내용에 입력된 값이 허용된 최대 길이를 초과했습니다.',
        max: '내용은 76자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 5회까지만 허용됩니다.',
        enabledVariable: '내용에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '내용은 URL 형식을 포함할 수 없습니다.',
      },
      header: {
        dbmax: '제목에 입력된 내용이 허용된 최대 길이를 초과했습니다.',
        max: '제목은 20자 이하여야 합니다.',
        enabledVariable: '제목에 허용하지 않는 변수가 포함되어 있습니다.',
        disallowedUrlLink: '제목은 URL 형식을 포함할 수 없습니다.',
      },
      image: { imageId: '썸네일 이미지 아이디는 UUID 형식 이어야 합니다.' },
      video: {
        // max: '동영상 URL은 2,000자 이하여야 합니다.',
        max: '동영상 URL은 500자 이하여야 합니다.',
        required: '동영상 URL은 필수입니다.',
        // url: '동영상 URL은 https://tv.kakao.com/v/ 로 시작하는 형식이어야 합니다.',
        url: '동영상 URL은 https://tv.kakao.com/v/#{숫자} 또는 https://tv.kakao.com/channel/#{숫자}/cliplink/#{숫자} 형식이어야 합니다.',
      },
    },
    image: {
      sms: {
        size: 'MMS 이미지의 용량은 100KB 이하여야 합니다.',
        extension: 'MMS 이미지는 jpg 또는 jpeg 형식만 지원합니다.',
      },
      carouselCommerce: {
        extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
        height: { max: '이미지의 높이는 4500px 이하여야 합니다.' },
        ratio: {
          max: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
          min: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        },
        size: '이미지의 용량은 5MB 이하여야 합니다.',
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4500px 이하여야 합니다.',
        },
      },
      carouselFeed: {
        extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
        height: { max: '이미지의 높이는 4500px 이하여야 합니다.' },
        ratio: {
          max: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
          min: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        },
        size: '이미지의 용량은 5MB 이하여야 합니다.',
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4500px 이하여야 합니다.',
        },
      },
      normal: {
        extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4500px 이하여야 합니다.',
        },
        ratio: {
          max: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
          min: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
        },
        size: '이미지의 용량은 5MB 이하여야 합니다.',
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4500px 이하여야 합니다.',
        },
      },
      wide: {
        extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
        size: '이미지의 용량은 5MB 이하여야 합니다.',
        widthHeight: '이미지의 가로 길이는 800px, 세로 길이는 600px이어야 합니다.',
      },
      wideItemList: {
        extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
        height: {
          min: '이미지의 높이는 400px 이어야 합니다.',
          max: '이미지의 높이는 4500px 이어야 합니다.',
        },
        size: '이미지의 용량은 5MB 이하여야 합니다.',
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 1:1 혹은 2:1 이어야 합니다.',
      },
      file: {
        required: '이미지는 필수입니다.',
      },
      imageName: {
        required: '이미지명은 필수입니다.',
        max: '이미지명은 25자 이하여야 합니다.',
      },
      extension: '지원하지 않는 형식 파일입니다.',
    },
    kakaoProfile: {
      required: '카카오 프로필은 필수입니다.',
      uuid: '카카오 프로필은 UUID 형식이어야 합니다.',
    },
    outgoingPhone: { required: '발신 번호는 필수입니다.' },
    personalizationFields: { required: '고객설정은 필수입니다.' },
    preTemplateId: { required: '사전 템플릿 아이디는 필수입니다.' },
    preTemplates: {
      templateName: {
        max: '템플릿 명은 25자 이하여야 합니다.',
        required: '템플릿 명은 필수입니다.',
      },
    },
    recipientNumber: {
      required: '수신 번호는 필수입니다.',
      enabledVariable: '허용되지 않은 발신번호를 선택했습니다. 다른 번호를 선택해 주세요.',
      variable: '수신번호는 사용가능한 필드를 선택해야 합니다. 다시 선택해 주세요.',
    },
    rejectPhone: { required: '수신 거부 번호는 필수입니다.' },
    subject: { max: '제목은 30자 이하여야 합니다.' },
    friendtalkCommerce: {
      commerce: '할인 가격 입력시, 할인율 또는 정액 할인 가격 중 하나는 반드시 입력해야 합니다.',
    },
    additionalFields: {
      required: '추가 정보는 필수입니다.',
      max: '추가 정보는 100자 이하여야 합니다.',
      maxLength: '추가 정보는 최대 10개까지만 추가할 수 있습니다.',
      enabledVariable: '추가 정보에 허용하지 않는 변수가 포함되어 있습니다.',
    },
    targetingSettings: {
      required: '타겟팅 설정은 필수입니다.',
      type: '허용하지 않는 타겟팅 설정 유형입니다.',
    },
    BRANDTALK_TEXT: {
      buttons: {
        coupon: { maxFive: '쿠폰이 포함된 경우, 버튼은 최대 4개까지만 추가할 수 있습니다.' },
        maxLength: '버튼은 최대 5개까지만 추가할 수 있습니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        required: '내용은 필수입니다.',
        max: '내용은 1,300자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 99회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
    },
    BRANDTALK_IMAGE: {
      buttons: {
        coupon: { maxFive: '쿠폰이 포함된 경우, 버튼은 최대 4개까지만 추가할 수 있습니다.' },
        maxLength: '버튼은 최대 5개까지만 추가할 수 있습니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        required: '내용은 필수입니다.',
        max: '내용은 400자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 29회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        max: '이미지 링크는 1,000자 이하여야 합니다.',
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        disallowedVariable: '이미지 링크는 변수를 사용할 수 없습니다.',
      },
    },
    BRANDTALK_WIDE_IMAGE: {
      buttons: { maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      content: {
        required: '내용은 필수입니다.',
        max: '내용은 76자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 1회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '내용은 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        max: '이미지 링크는 1,000자 이하여야 합니다.',
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        disallowedVariable: '이미지 링크는 변수를 사용할 수 없습니다.',
      },
    },
    BRANDTALK_WIDE_ITEM_LIST: {
      buttons: { maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      header: {
        required: '메인 아이템 제목은 필수입니다.',
        max: '메인 아이템 제목은 20자 이하여야 합니다.',
        maxLine: '메인 아이템 제목에서는 줄바꿈을 사용할 수 없습니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '메인 아이템 제목은 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      content: {
        required: '내용은 필수입니다.',
        firstMax: '메인 아이템 내용은 25자 이하여야 합니다.',
        max: '내용은 30자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 1회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '아이템 내용은 URL 형식을 포함할 수 없습니다.',
      },
      mobileLink: {
        required: '모바일 웹 링크은 필수입니다.',
        max: '모바일 웹 링크는 1,000자 이하여야 합니다.',
        laxUrl: '모바일 웹 링크는 URL 형식이어야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      pcLink: {
        max: 'PC 웹 링크는 1,000자 이하여야 합니다.',
        laxUrl: 'PC 웹 링크는 URL 형식이어야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      androidDeepLink: {
        max: '안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      iosDeepLink: {
        max: 'iOS 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      list: {
        max: '아이템은 최대 4개까지만 추가할 수 있습니다.',
        min: '아이템은 최소 3개 이상이어야 합니다.',
      },
    },
    BRANDTALK_COMMERCE: {
      buttons: {
        maxLength: '버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      title: {
        required: '상품명은 필수입니다.',
        max: '상품명은 30자 이하여야 합니다.',
        maxLine: '상품명에서는 줄바꿈을 사용할 수 없습니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '상품명은 URL 형식을 포함할 수 없습니다.',
      },
      regularPrice: {
        integer: '정상 가격은 숫자여야 합니다.',
        max: '정상 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '정상 가격은 0 이상의 숫자여야 합니다.',
        positive: '정상 가격은 숫자여야 합니다.',
        required: '정상 가격은 필수입니다.',
      },
      discountPrice: {
        integer: '할인 가격은 숫자여야 합니다.',
        max: '할인 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '할인 가격은 숫자여야 합니다.',
        required: '할인 가격은 필수입니다.',
      },
      discountRate: {
        integer: '할인율은 숫자여야 합니다.',
        max: '할인율은 100 이하의 숫자여야 합니다.',
        min: '할인율은 0 이상의 숫자여야 합니다.',
        positive: '할인율은 숫자여야 합니다.',
        required: '할인율은 필수입니다.',
      },
      discountFixed: {
        integer: '정액 할인 가격은 숫자여야 합니다.',
        max: '정액 할인 가격은 999,999 이하의 숫자여야 합니다.',
        min: '정액 할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '정액 할인 가격은 숫자여야 합니다.',
        required: '정액 할인 가격은 필수입니다.',
      },
      additionalContent: {
        variableFormat: '올바르지 않은 변수 형식입니다.',
        max: '부가 정보는 34자 이하여야 합니다.',
        maxLine: '부가 정보의 줄바꿈은 최대 1회까지만 허용됩니다.',
        disallowedUrlLink: '부가 정보는 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 1,000자 이하여야 합니다.',
        disallowedVariable: '이미지 링크는 변수를 사용할 수 없습니다.',
      },
      commerce: '할인 가격 입력시, 할인율 또는 정액 할인 가격 중 하나는 반드시 입력해야 합니다.',
      brandCommerce: '할인율 또는 정액할인가격 둘중에 하나만 입력해야 합니다.',
    },
    BRANDTALK_CAROUSEL_FEED: {
      buttons: {
        maxLength: '캐러셀 타입의 버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '캐러셀 타입의 버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      header: {
        required: '제목은 필수입니다.',
        max: '제목은 20자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '제목은 URL 형식을 포함할 수 없습니다.',
      },
      content: {
        required: '내용은 필수입니다.',
        max: '내용은 180자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 2회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '내용은 URL 형식을 포함할 수 없습니다.',
      },
      image: {
        imageId: '이미지 아이디는 UUID 형식이어야 합니다.',
        required: '이미지는 필수입니다.',
      },
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 1,000자 이하여야 합니다.',
        disallowedVariable: '이미지 링크는 변수를 사용할 수 없습니다.',
      },
      list: {
        max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
        min: '캐러셀은 최소 2개 이상이어야 합니다.',
      },
    },
    BRANDTALK_CAROUSEL_COMMERCE: {
      introImage: {
        imageId: '인트로 이미지의 아이디는 UUID 형식이어야 합니다.',
        ratio: '인트로 이미지의 가로 : 세로 비율이 일치해야 합니다.',
        required: '인트로 이미지는 필수입니다.',
      },
      header: {
        max: '인트로 제목은 20자 이하여야 합니다.',
        required: '인트로 제목은 필수입니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '인트로 제목은 URL 형식을 포함할 수 없습니다.',
      },
      content: {
        max: '인트로 내용은 50자 이하여야 합니다.',
        required: '인트로 내용은 필수입니다.',
        maxLine: '인트로 내용의 줄바꿈은 최대 2회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '인트로 내용은 URL 형식을 포함할 수 없습니다.',
      },
      mobileLink: {
        laxUrl: '인트로 모바일 링크는 URL 형식이어야 합니다.',
        max: '인트로 모바일 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      pcLink: {
        laxUrl: '인트로 PC 링크는 URL 형식이어야 합니다.',
        max: '인트로 PC 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      iosDeepLink: {
        max: '인트로 iOS 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      androidDeepLink: {
        max: '인트로 안드로이드 앱 링크는 1,000자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
      },
      image: {
        imageId: '이미지의 아이디는 UUID 형식이어야 합니다.',
        ratio: '이미지의 가로 : 세로 비율이 일치해야 합니다.',
        required: '이미지는 필수입니다.',
      },
      additionalContent: {
        max: '부가 정보는 34자 이하여야 합니다.',
        maxLine: '부가 정보의 줄바꿈은 최대 1회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '부가 정보는 URL 형식을 포함할 수 없습니다.',
      },
      buttons: {
        maxLength: '캐러셀 타입의 버튼은 최대 2개까지만 추가할 수 있습니다.',
        minLength: '캐러셀 타입의 버튼은 최소 1개 이상이어야 합니다.',
      },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      title: {
        required: '상품명은 필수입니다.',
        max: '상품명은 30자 이하여야 합니다.',
        maxLine: '상품명에서는 줄바꿈을 사용할 수 없습니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '상품명은 URL 형식을 포함할 수 없습니다.',
      },
      regularPrice: {
        integer: '정상 가격은 숫자여야 합니다.',
        max: '정상 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '정상 가격은 0 이상의 숫자여야 합니다.',
        positive: '정상 가격은 숫자여야 합니다.',
        required: '정상 가격은 필수입니다.',
      },
      discountPrice: {
        integer: '할인 가격은 숫자여야 합니다.',
        max: '할인 가격은 99,999,999 이하의 숫자여야 합니다.',
        min: '할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '할인 가격은 숫자여야 합니다.',
      },
      discountRate: {
        integer: '할인율은 숫자여야 합니다.',
        max: '할인율은 100 이하의 숫자여야 합니다.',
        min: '할인율은 0 이상의 숫자여야 합니다.',
        positive: '할인율은 숫자여야 합니다.',
      },
      discountFixed: {
        integer: '정액 할인 가격은 숫자여야 합니다.',
        max: '정액 할인 가격은 999,999 이하의 숫자여야 합니다.',
        min: '정액 할인 가격은 0 이상의 숫자여야 합니다.',
        positive: '정액 할인 가격은 숫자여야 합니다.',
      },
      list: {
        length: {
          max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
          min: '캐러셀은 최소 2개 이상이어야 합니다.',
        },
      },
      commerce: '할인 가격 입력시, 할인율 또는 정액 할인 가격 중 하나는 반드시 입력해야 합니다.',
      brandCommerce: '할인율 또는 정액할인가격 둘중에 하나만 입력해야 합니다.',
      imageLink: {
        laxUrl: '이미지 링크는 URL 형식이어야 합니다.',
        max: '이미지 링크는 1,000자 이하여야 합니다.',
        disallowedVariable: '비즈니스 ID는 변수를 사용할 수 없습니다.',
      },
    },
    BRANDTALK_PREMIUM_VIDEO: {
      buttons: { maxLength: '버튼은 최대 1개까지만 추가할 수 있습니다.' },
      coupon: { maxLength: '쿠폰은 최대 1개까지만 추가할 수 있습니다.' },
      image: { imageId: '썸네일 이미지 아이디는 UUID 형식 이어야 합니다.' },
      header: {
        max: '제목은 20자 이하여야 합니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '제목은 URL 형식을 포함할 수 없습니다.',
      },
      content: {
        max: '내용은 76자 이하여야 합니다.',
        maxLine: '내용의 줄바꿈은 최대 1회까지만 허용됩니다.',
        variableFormat: '올바르지 않은 변수 형식입니다.',
        disallowedUrlLink: '내용은 URL 형식을 포함할 수 없습니다.',
      },
      video: {
        max: '동영상 URL은 500자 이하여야 합니다.',
        required: '동영상 URL은 필수입니다.',
        url: '동영상 URL은 https://tv.kakao.com/v/#{숫자} 또는 https://tv.kakao.com/channel/#{숫자}/cliplink/#{숫자} 형식이어야 합니다.',
        disallowedVariable: '동영상 URL은 변수를 사용할 수 없습니다.',
      },
    },
    brandImage: {
      extension: '이미지는 .jpg 또는 .png 형식만 지원합니다.',
      unsupportedExtension: '지원하지 않는 형식 파일입니다.',
      size: '이미지의 용량은 5MB 이하여야 합니다.',
      normal: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4,500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4,500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
      wide: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4,500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4,500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 2:1 이상, 1:1 이하여야 합니다.',
      },
      mainWideItemList: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4,500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4,500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 2:1이어야 합니다.',
      },
      wideItemList: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4,500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 500px 이상이어야 합니다.',
          max: '이미지의 높이는 4,500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 1:1이어야 합니다.',
      },
      carouselFeed: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4,500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
      carouselCommerce: {
        width: {
          min: '이미지의 너비는 500px 이상이어야 합니다.',
          max: '이미지의 너비는 4500px 이하여야 합니다.',
        },
        height: {
          min: '이미지의 높이는 250px 이상이어야 합니다.',
          max: '이미지의 높이는 4500px 이하여야 합니다.',
        },
        ratio: '이미지의 가로 : 세로 비율은 2:1 이상, 3:4 이하여야 합니다.',
      },
    },
    emoji: {
      subjectAndContent: '제목과 본문에 허용되지 않는 문자가 있습니다.',
    },
  },
  navigation: {
    mainTitle: '문자/카카오',
    subTitle: '메시지',
    message: '문자메시지',
    friendtalk: '브랜드\n메세지\n(자유형)',
    alimtalk: '알림톡',
    brand: '브랜드\n 메시지',
    shippingResult: '발송결과',
    reserve: '예약현황',
    // TODO
    details: '메시지 설정',
    result: '발송결과',
    language: {
      select: '언어선택',
      korean: '한국어',
      english: '영어',
    },
    finance: {
      select: '암호화 *',
      default: '적용 안함',
      aes256: 'AES256 - 가명',
      aria256: 'ARIA256 - 가명',
    },
  },
  preview: {
    title: '미리보기',
    fallback: '대체발송',
    content: '내용을 입력해 주세요.',
    brandMessageInfo: [
      '이 채널 사업자의 광고성 정보 수신 동의 시 메시지가',
      '발송되며, 모바일 데이터 이용 시 요금이 발생할 수 있습니다.',
      '수신을 원하지 않을 경우 여기를 눌러 채널을 차단해 주세요.',
    ],
  },
  button: {
    reset: '내용 초기화',
    messageLoad: '템플릿 불러오기',
    attachImage: '이미지 첨부',
    imageLoad: '불러오기',
    imageUpload: '등록하기',
    regist: '등록',
    add: '추가',
    delete: '삭제',
    confirm: '확인',
    cancel: '취소',
    fileUpload: '파일 업로드',
    imageRegist: '등록',
    templateRegist: '등록',
    send: '사용',
    notSend: '사용 안함',
    use: '사용',
    notUse: '사용 안함',
    buttonSetting: '버튼 설정',
    couponLoad: '쿠폰 불러오기',
    tailSetting: '더보기 설정',
    new: '신규',
    select: '선택',
    viewDetails: '상세보기',
    preview: '미리보기',
    exit: '나가기',
    save: '저장',
    duplicate: '복제본 만들기',
    previewOpen: '미리보기 열기',
    previewClose: '미리보기 닫기',
    imageUrlCopy: '이미지 URL 복사하기',
  },
  title: {
    templateList: '템플릿 목록',
    templateRegist: '템플릿 등록',
    imageList: '이미지 목록',
    imageRegist: '이미지 등록',
    shippingResult: '발송결과',
    fallbackSetting: '대체발송 설정',
    buttonSetting: '버튼 설정',
    couponSetting: '쿠폰 설정',
    couponRegist: '쿠폰 등록',
    couponList: '쿠폰 목록',
    tailSetting: '더보기 설정',
    templatePreview: '템플릿 미리보기',
    additionalFields: '기타 정보',
  },
  label: {
    type: '유형',
    types: '타입',
    templateName: '템플릿명',
    required: '필수',
    optional: '선택',
    advert: '광고성 여부',
    send: '발송함',
    notSend: '발송안함',
    imageName: '이미지명',
    attachImage: '이미지 첨부',
    mobileWebLink: '모바일 웹 링크',
    pcWebLink: 'PC 웹 링크',
    iosDeepLink: 'iOS 앱 링크',
    androidDeepLink: '안드로이드 앱 링크',
    buttonType: '버튼유형',
    couponType: '쿠폰유형',
    couponName: '쿠폰명',
    couponValue: '쿠폰값',
    couponDescription: '쿠폰 상세 설명',
    addVariable: '변수값 추가',
    checkVariable: '저장된 변수값 확인',
    kakaoProfile: '카카오프로필',
    recipientNumber: '수신번호',
    rejectPhone: '수신거부번호',
    customerSetting: '고객설정',
    department: '담당 부서',
    messageSetting: '메시지 설정',
    nightSend: '야간 발송',
    outgoingPhone: '발신번호',
    fallback: '대체발송',
    messageType: '메시지 유형',
    couponSetting: '쿠폰 설정',
    adultsMessages: '성인용 메시지 여부',
    redelivery: '익일발송여부',
    buttonName: '버튼명',
    closeVariable: '저장된 변수값 닫기',
    coupon: '쿠폰',
    informationalMessage: '정보성 메시지',
    advertisingMessage: '광고성 메시지',
    tailSetting: '더보기 설정',
    isAdvertising: '광고성 여부란?',
    resultInformation: '결과 파일 포함 정보',
    set: '설정함',
    notSet: '설정안함',
    all: '전체',
    beforeTransmission: '데이터전송전',
    afterTransmission: '데이터전송후',
    messageTypes: '메시지 타입',
    imageTypes: '이미지 타입',
    additionalFields: '추가 정보{count}',
    targetingSettings: '타겟팅 설정',
    isTargetingSettings: '타겟팅 설정이란?',
    template: '템플릿',
    isPushNotification: '푸시 알림 여부',
    buttonSetting: '버튼 설정',
    content: '내용',
    businessFormType: '비즈니스 폼 유형',
    businessFormID: '비즈니스 ID',
  },
  placeholder: {
    imageName: '이미지명',
    templateName: '관리용 제목을 입력해 주세요. (25자 이내)',
    search: '검색어',
    character: '최대 {count}자',
    characters: '최대 {count}자까지 입력가능합니다.',
    link: 'http://',
    link2: '[http://, https://]를 포함한 URL',
    coupon: {
      NUMBER_DISCOUNT: '1이상 99,999,999까지 입력가능합니다.',
      PERCENT_DISCOUNT: '1 이상 100까지 입력가능합니다.',
      DELIVERY_DISCOUNT: '',
      FREE_COUPON: '1이상 99,999,999까지 입력가능합니다.',
      UP_COUPON: '최대 7자까지 입력가능합니다.',
    },
    button: '버튼을 입력해주세요.',
    char: '자',
    line: '줄',
  },
  tableHead: {
    type: '유형',
    templateName: '템플릿명',
    createdDate: '등록일',
    journeyName: '저니명',
    journeyVersion: '저니버전',
    activityName: '액티비티명',
    messageType: '메시지 유형',
    sendAllCnt: '발송타겟수',
    sendStart: '발송시작',
    sendEnd: '발송종료',
    successCnt: '성공건수',
    imageSize: '크기',
    couponName: '쿠폰명',
    couponDescription: '쿠폰 상세 설명',
    mobileWebLink: '모바일 웹 링크',
    tickets: '발송티켓수',
  },
  comment: {
    variable: '※ 입력할 위치를 클릭한 후, 변수 버튼을 누르면 삽입됩니다.',
    variable2: '※ 변수값은 #을 입력후 선택하세요',
    noResult: '검색 결과가 없습니다.',
    nightSend: '※ 야간 시간에 광고성 정보를 전송하려면 별도의 동의가 필요합니다.',
    noImage: '등록된 이미지가 없습니다.',
    redelivery: '20:00 ~ 08:00 에는 메시지 전송이 제한됩니다. 익일 발송 선택 시 다음날 08시 부터 메시지가 발송되며, 선택하지 않을 경우 메시지가 발송되지 않습니다.',
    adultsMessages: '성인용 메시지는 브랜드 메시지 템플릿 등록 시에만 적용 가능합니다.',
    variableMessage: '변수명이 사용 가능한 필드입니다.',
    urlLinkMessage: 'URL 형식이 사용 가능한 필드입니다.',
    image: {
      kakaoExtension: 'jpg 또는 png 형식만 지원',
      kakaoCopyright: '카카오의 로고, 상표, 서비스명, 저작물 무단 사용 및 정보성(알림톡)/광고성(친구톡) 메시지 작성 시 가이드 위반으로 서비스 이용이 제한될 수 있음',
      mms: {
        extension: 'jpg 또는 jpeg 형식만 지원',
        limit: '100KB 이하',
      },
      kakaoBasic: {
        volume: '500KB 이하',
        wideVolume: '5MB 이하',
        size: '최소 500×250px (가로:세로 비율 2:1 이상 3:4 이하)',
        wideSize: '와이드 이미지는 가로 길이 800px, 세로 길이 600px이어야 합니다.',
        limit: '와이드 이미지 발송 시, 텍스트 문구 + 링크 버튼(2개) + 이미지 발송이 가능합니다. 텍스트 문구는 최대 76자로 제한됩니다.',
      },
      wideItemList: {
        volume: '5MB 이하',
        size: '가로 길이 500px이상',
        crop: '이미지의 가로 : 세로 비율은 1:1 혹은 2:1 이어야 합니다.',
      },
      normal: {
        volume: '- 이미지 크기는 일반 이미지 500KB 이하여야 합니다.',
        size: '- 일반 이미지는 가로 길이는 최소 500px, 세로 길이는 최소 250px 이상이어야 합니다.',
      },
      carouselFeed: {
        volume: '5MB 이하',
        size: '가로 길이 500px이상 (가로:세로 비율 2:1 이상 3:4 이하)',
      },
      carouselCommerce: {
        volume: '5MB 이하',
        sameRatio: '캐러셀 커머스 발송에 사용되는 이미지들은 모두 동일한 비율이어야 함',
        size: '가로 길이 500px이상 (가로:세로 비율 2:1 이상 3:4 이하)',
      },
      commerce: {
        size: '- 일반 이미지는 가로 길이는 최소 500px, 세로 길이는 최소 250px 이상이어야 합니다.',
      },
    },
    brandImage: {
      image: {
        volume: '5MB 이하',
        recommendedSize: '권장 사이즈: 800 X 400px (가로 500px 이상)',
        size: '- 최소 500 X 250px (가로:세로 비율 2:1 이상 3:4 이하)',
      },
      wide: {
        volume: '5MB 이하',
        recommendedSize: '권장 사이즈: 800 X 600px (가로 500px 이상)',
        size: '- 최소 500 X 250px (가로:세로 비율 2:1 이상 3:4 이하)',
      },
      mainWideItemList: {
        volume: '5MB 이하',
        size: '- 제한 사이즈: 가로 500px 이상',
        ratio: '- 가로:세로 비율: 2:1',
      },
      wideItemList: {
        volume: '5MB 이하',
        size: '- 제한 사이즈: 가로 500px 이상',
        ratio: '- 가로:세로 비율: 1:1',
      },
      carouselFeed: {
        volume: '5MB 이하',
        recommendedSize: '권장 사이즈: 800 X 600px 또는 800 X 400px (가로 500px 이상)',
        size: '- 최소 500 X 250px (가로:세로 비율 2:1 이상 3:4 이하)',
      },
      carouselCommerce: {
        volume: '5MB 이하',
        recommendedSize: '권장 사이즈: 800 X 600px 또는 800 X 400px (가로 500px 이상)',
        size: '- 최소 500 X 250px (가로:세로 비율 2:1 이상 3:4 이하)',
        sameRatio: '캐러셀 커머스 발송에 사용되는 이미지들은 모두 동일한 비율이어야 함',
      },
      commerce: {
        volume: '5MB 이하',
        recommendedSize: '권장 사이즈: 800 X 400px (가로 500px 이상)',
        size: '- 최소 500 X 250px (가로:세로 비율 2:1 이상 3:4 이하)',
      },
    },
    selectPhoneNumber: '전화번호 필드를 선택하세요.',
    resultInformation: '※ 해당 정보는 고객에게 발송되지 않으며, 관리자 기록용으로 사용됩니다.',
    fallback: '카카오톡 발송 실패 시 문자메시지로 발송됩니다.',
    couponLink: [
      '링크 파라미터의 경우 다음 두 가지 중 하나를 충족해야 합니다.',
      '* 모바일 웹 링크 사용',
      '* 안드로이드 또는 iOS 링크 둘 중 하나에 카카오 채널 쿠폰 URL(포맷: alimtalk=coupon://) 사용',
    ],
    alimtalk: [
      '\'알림톡\'은 카카오톡 채널을 추가하지 않은 이용자에게도 발송 가능한',
      '정보성 메시지',
      '입니다.',
    ],
    friendtalk: [
      '\'친구톡\' 은 카카오톡 채널을 맺은 이용자 대상으로 발송하는',
      '광고성 메시지',
      '입니다.',
    ],
    carousel: [
      '※ 캐러셀은 ',
      '최대 10개',
      '까지 추가 가능합니다.',
      '최대 6개',
    ],
    brandMessage: [
      '브랜드 메시지는 ',
      '야간(20시 ~ 익일 08시) 발송이 제한',
      '됩니다.',
    ],
    brandVariable: [
      '변수명은 #{변수} 와 같이 사용하여야 하며',
      '변수는 영어, 한글, 숫자, -, _ 를 사용하실 수 있습니다.',
      '템플릿 등록시 변수명은 20자까지만 사용가능합니다.',
      '할인금액, 할인율, 상품명, 정상가격, 할인가격, 정액할인가격은 변수로 사용할 수 없습니다.',
    ],
  },
  alert: {
    notification: '알림',
    dataExtension: '{key} 은 DataExtension에 존재하지 않습니다.',
    forbidden: '권한이 없습니다.',
    unauthorized: '비인가된 정보입니다.',
    advert: {
      subject: '광고성 문자 발송 안내',
      content: `광고성 문자는 문자 최상단 '<span class="bold">(광고)</span>'문구와 <span class="bold">전송자의 명칭, 수신거부번호</span>를 본문에 반드시 포함하여야 합니다.

이를 어길 시, '정보통신망법 제 76조 제1항 제8호'에 의거하여 3천만원 이하의 과태료가 부과됩니다.

예시)
<span class="bold">(광고) 아이투맥스</span>
광고메시지
<span class="bold">무료수신거부 0801234567</span>`,
    },
    deleteSelect: {
      subject: '알림',
      content: '삭제할 항목을 선택해 주세요.',
    },
    advertGuide: {
      title: '정보성/광고성 메시지 안내',
      info: {
        title: '정보성 메시지란?',
        content: '정보통신망법 안내서에 \'영리목적 광고성 정보의 예외\'에 해당하는 메시지',
        anchor: '스팸방지 정보통신망법 안내서',
      },
      advert: {
        title: '광고성 메시지란?',
        subTitle: '전송자가 경제적 이득을 취할 목적으로 전송하는 메시지',
        content: [
          '전송자에 관한 정보',
          '전송자가 제공할 재화나 서비스에 관한 정보',
        ],
      },
      requiredInclusions: {
        title: '필수 포함 사항',
        content: [
          {
            title: '광고 표시',
            content: '메시지 제목 또는 내용 맨 앞에 (광고) 문구를 반드시 표시해야 합니다.',
          },
          {
            title: '전송자의 연락처 표시',
            content: '발신인의 명칭과 연락처(전화번호 또는 주소)를 정확히 표기해야 합니다.',
          },
          {
            title: '수신거부 방법 표시',
            content: '수신자가 수신거부를 쉽게 할 수 있는 방법을 안내하고, 무료로 이용할 수 있는 수단을 제공해야 합니다.',
          },
        ],
      },
    },
    advertWarning: {
      title: '광고성 메시지 발송 안내',
      caution: {
        title: '주의사항',
        content: [
          '광고성 문자 발송 시 아래 필수 표기 사항을 반드시 포함해야 합니다.',
          '위반 시 정보통신망법 제76조 제1항 제8호에 의거하여 3천만원 이하의 과태료가 부과됩니다.',
        ],
      },
      requiredNotation: {
        title: '필수 표기 사항',
        content: [
          '내용 맨 앞에 (광고) 문구 삽입',
          '전송자 업체명 또는 서비스명 기재',
          '무료수신거부 방법 기재',
        ],
      },
      example: {
        title: '올바른 예시',
        content: [
          '(광고) 아이투맥스',
          '광고메시지',
          '무료수신거부 0801234567',
        ],
      },
    },
    targetingSettings: {
      title: '타겟팅 설정',
      img01: [
        '고객사 발송',
        '요청 대상',
      ],
      img02: [
        '채널 친구',
        '유저',
      ],
      m: {
        title: '광고주 마수동 유저(카카오 수신 동의)',
        content: [
          '광고주의 마수동 유저(카카오 수신 동의) 대상으로 광고성',
          '메시지를 발송 처리를 합니다.',
        ],
      },
      n: {
        title: '광고주 마수동 유저(카카오 수신 동의) - 채널 친구',
        content: [
          '광고주의 마수동 유저(카카오 수신 동의)에서 채널 친구를',
          '제외하고 광고성 메시지를 발송 처리합니다.',
        ],
      },
      i: {
        title: '광고주 발송 요청 대상 ∩ 채널 친구',
        content: [
          '광고주 발송 요청 대상에서, 채널 친구인 경우에만',
          '광고성 메시지를 발송 처리합니다.',
        ],
      },
    },
    cautionTitle: '주의',
    removeButton: '버튼을 삭제하시겠습니까?',
    removeAdditionalField: '추가 정보를 삭제하시겠습니까?',
    removeCoupon: '쿠폰을 삭제하시겠습니까?',
    // TODO
    discard: {
      title: '저장되지 않은 변경 사항',
      content: '저장되지 않은 변경 사항이 있는 활동을 닫으려고 합니다. 이렇게 하면 변경 사항이 손실됩니다. 계속하시겠습니까?',
      cancel: '취소',
      ok: '변경사항 취소',
    },
    imageUrlCopy: '이미지 URL이 복사되었습니다.',
    imageUrlCopyFail: '브라우저 보안 정책으로 인해 iframe 화면에서는 복사가 지원되지 않습니다. 링크를 직접 선택해 복사해 주세요.',
  },
  update: {
    title: '시스템 업그레이드 알림',
    content: [
      '현재 시스템 버전이 업데이트되었습니다.',
      '진행 상황을 저장하시고, 페이지를 강력 새로 고침해 주세요.',
    ],
  },
  globalError: `오류가 발생하였습니다.
관리자에게 문의 부탁드립니다.
i2message_support{'@'}i2max.co.kr`,
};
